export const COLLECTION_TIME_FILTERS = {
  THIS_WEEK: 'this_week',
  NEXT_WEEK: 'next_week',
} as const;
